import Vue from "vue";
import Loading from "./index.vue";
const loadingVueConstructor = Vue.extend(Loading);
let instance = null;
Vue.directive("loading", {
  bind: function(el, binding, vnode) {
    instance = new loadingVueConstructor({
      el: document.createElement("div"),
      data: {
        show: binding.value
      }
    });
    el.instance = instance;
    el.appendChild(instance.$el);
    // console.log(el.style.width);
    // console.log(el.style.position, 89);
    let style = el.style;
    Vue.nextTick(() => {
      const positon = "fixed";
      // getStyle(el,'position')
      if (!["relative", "fixed", "absolute"].includes(positon)) {
        el.style.position = "relative";
        el.style.overflow = "hidden";
      }
    });
  },

  update: function(el: any, binding) {
    const $instance: any = el.instance;
    $instance.show = binding.value;
  },

  unbind: function(el, binding) {}
});
